import React from 'react';
import PropTypes from 'prop-types';

import Checklist from '../elements/Checklist';
import Drawer from '../elements/Drawer';

const CarrierProductsDrawer = ({
  carrierName,
  lineOfBusiness = 'life',
  onClose,
  onChange,
  products,
  selectedProductIds
}) => {
  const options = {};

  switch (lineOfBusiness) {
    case 'ltc':
      options['Long Term Care'] = products.filter(p => p.product_type === 'Long Term Care');
      break;
    case 'annuities':
      options['Fixed Annuity'] = products.filter(p => p.product_type === 'Fixed Annuity');
      options['Fixed Indexed Annuity'] = products.filter(
        p => p.product_type === 'Fixed Indexed Annuity'
      );
      options['Multi-Year Guaranteed Annuity'] = products.filter(
        p => p.product_type === 'Multi-Year Guaranteed Annuity'
      );
      break;
    default:
      options['Term'] = products.filter(p => p.product_type === 'Term');
      options['Universal Life (UL)'] = products.filter(p => p.product_type === 'UL');
      options['Indexed Universal Life (IUL)'] = products.filter(p => p.product_type === 'IUL');
      options['Term Return of Premium (ROP)'] = products.filter(p => p.product_type === 'Term ROP');
      options['Final Expense'] = products.filter(p => p.product_type === 'Final Expense');
      options['Whole Life'] = products.filter(p => p.product_type === 'Whole Life');
  }

  const handleProductToggle = (categoryProductIds, newCategorySelectedIds) => {
    const categorySet = new Set(categoryProductIds);
    const remainingSelected = (selectedProductIds || []).filter(id => !categorySet.has(id));

    onChange([...remainingSelected, ...newCategorySelectedIds]);
  };

  return (
    <Drawer
      alignRight={true}
      onClose={onClose}
      show={true}
      title={`Filter ${carrierName}'s Products`}
    >
      {Object.keys(options).map((type_name, i) => {
        const type_products = options[type_name];

        if (type_products.length) {
          const categoryProductIds = type_products.map(p => p.id);
          const categorySelectedIds = (selectedProductIds || []).filter(id =>
            categoryProductIds.includes(id)
          );

          return (
            <Checklist
              key={i}
              label={type_name}
              onChange={newSelected => handleProductToggle(categoryProductIds, newSelected)}
              options={type_products.map(p => ({
                value: p.id,
                label: p.product_name
              }))}
              selected={categorySelectedIds}
              showSelectAll={false}
              style={{ marginBottom: 30 }}
            />
          );
        }

        return null;
      })}
    </Drawer>
  );
};

CarrierProductsDrawer.propTypes = {
  carrierName: PropTypes.string,
  lineOfBusiness: PropTypes.string,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  products: PropTypes.array,
  selectedProductIds: PropTypes.array
};

export default CarrierProductsDrawer;
